import { render, staticRenderFns } from "./SidCheckbox.vue?vue&type=template&id=83695052"
import script from "./SidCheckbox.vue?vue&type=script&lang=js"
export * from "./SidCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports